import { SUCCESS, REQUEST, ERROR, SET_CURRENT, ROOT } from './types'
import { buildQuery } from '../../utils/buildQuery'

const pushUnique = (arr1, arr2, unique) => {
  arr2.forEach(el1 => {
    if (!arr1.find(el2 => el2[unique] === el1[unique])) {
      arr1.push(el1)
    }
  })
}

const state = {
  data: {
    pending: {},
    working: {},
    documents: {},
    gr: {},
    finished: {},
    analyze: {},
    // documentsGR: {},
    current: null,
  },
  filters: {
    pending: { search: ``, user: ``, page: 1, per_page: 10 },
    working: { search: ``, user: ``, page: 1, per_page: 10 },
    documents: { search: ``, user: ``, page: 1, per_page: 10 },
    gr: { search: ``, user: ``, page: 1, per_page: 10 },
    analyze: { search: ``, user: ``, page: 1, per_page: 10 },
    // documentsGR: { search: ``, user: ``, page: 1, per_page: 10 },
    finished: { search: ``, user: ``, page: 1, per_page: 10, today: true },
  },
  loading: {
    pending: false,
    working: false,
    documents: false,
    gr: false,
    analyze: false,
    // documentsGR: false,
    finished: false,
  },
  error: {
    pending: ``,
    working: ``,
    documents: ``,
    gr: ``,
    analyze: ``,
    // documentsGR: ``,
    finished: ``,
  },
  dialogs: {
    info: false,
    approve: false,
    reprove: false,
    edit: false,
    gr: false,
    // documentsGR: false,
    grType: 0,
  },
}

const getters = {
  cards: (state) => state.data,
  loading: (state) => state.loading,
  error: (state) => state.error,
  dialogs: (state) => state.dialogs,
}

const actions = {
  async getAssigned(context, status) {
    try {
      if (context.state.loading[status]) return
      context.commit(REQUEST, status);

      const filters = context.state.filters[status]
      const query = buildQuery({
        ...filters,
        status,
        sort_field: `assigned.created_at`,
        sort_direction: `ASC`,
      })

      const response = await context.dispatch(
        `api`,
        {
          entity: `priority`,
          action: `assigned`,
          query,
        },
        ROOT
      )

      if (response.status !== 200) throw response

      const { data } = response

      if (filters.page > 1) {
        context.commit(SUCCESS, { status })
        context.commit(`APPEND`, { status, payload: data })
      } else {
        context.commit(SUCCESS, { status, payload: data })
      }
      return data
    } catch (err) {
      console.error(err)
      context.commit(ERROR, {
        status,
        error: err.data.error || `Não foi possível carregar os dados.`
      })
      return err?.data
    }
  },

  async assignUser(context, { _id, assigned }) {
    try {
      context.commit(REQUEST, assigned.status)

      const response = await context.dispatch(
        `api`,
        {
          entity: `priority`,
          action: `assign`,
          params: { _id }
        },
        ROOT
      )

      if (response.status !== 200) throw response

      context.commit(SUCCESS, { status: assigned.status })
      return response.data
    } catch (err) {
      console.error(err)
      context.commit(ERROR, {
        status: assigned.status,
        error: err.data.error || `Não foi possível atribuir o motorista.`
      })
      return err?.data
    }
  },

  async block(context, { _id, status, oldStatus }) {
    try {
      context.commit(REQUEST, oldStatus)
      const response = await context.dispatch(
        `api`,
        {
          entity: `priority`,
          action: `block`,
          params: { _id, status }
        },
        ROOT
      )

      if (response.status !== 200) throw response

      context.commit(SUCCESS, { status: oldStatus })
      return response.data
    } catch (err) {
      console.error(err)
      context.commit(ERROR, {
        status: oldStatus,
        error: err.data.error || `Não foi possível mudar o motorista.`
      })
      return err?.data
    }
  },

  async finish(context, { _id, oldStatus, status }) {
    try {
      context.commit(REQUEST, oldStatus)
      const response = await context.dispatch(
        `api`,
        {
          entity: `priority`,
          action: `finish`,
          params: { _id },
          payload: { status }
        },
        ROOT
      )

      if (response.status !== 200) throw response

      context.commit(SUCCESS, { status: oldStatus })
      return response.data
    } catch (err) {
      console.error(err)
      context.commit(ERROR, {
        status: oldStatus,
        error: err.data.error || `Não foi possível finalizar o cadastro.`
      })
      return err?.data
    }
  },

  async analyze(context, { _id, oldStatus, status }) {
    try {
      context.commit(REQUEST, oldStatus)
      const response = await context.dispatch(
        `api`,
        {
          entity: `priority`,
          action: `analyze`,
          params: { _id },
          payload: { status }
        },
        ROOT
      )

      if (response.status !== 200) throw response

      context.commit(SUCCESS, { status: oldStatus })
      return response.data
    } catch (err) {
      console.error(err)
      context.commit(ERROR, {
        status: oldStatus,
        error: err.data.error || `Não foi possível enviar para Análise.`
      })
      return err?.data
    }
  },

  async save(context, { driver, notes }) {
    try {
      const { dispatch } = context;
      const response = await dispatch(
        `api`,
        {
          entity: `priority`,
          action: `save`,
          params: driver,
          payload: {
            notes: notes,
          }
        },
        ROOT
      )

      if (response.status !== 200) throw response

      return response.data
    } catch (err) {
      console.error(err)
      return err?.data
    }
  }
}

const mutations = {
  [REQUEST](state, status) {
    state.loading[status] = true
  },
  [SUCCESS](state, { status, payload }) {
    payload && (state.data[status] = payload)
    state.loading[status] = false
    state.error[status] = ``
  },
  [ERROR](state, { status, error }) {
    state.error[status] = error
    state.loading[status] = false
  },
  [SET_CURRENT](state, current) {
    state.data.current = current
  },
  UPDATE_CURRENT(state, newCurrent) {
    Object.assign(state.data.current, { ...newCurrent, assigned: state.data.current.assigned })
  },
  SET_FILTERS(state, { status, filters }) {
    state.filters[status] = { ...state.filters[status], ...filters }
  },
  APPEND(state, { status, payload: { docs, ...rest } }) {
    pushUnique(state.data[status].docs, docs, `_id`)
    state.data[status] = { ...state.data[status], ...rest }
  },
  DIALOG(state, dialogs) {
    state.dialogs = {
      ...state.dialogs,
      ...dialogs,
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
